<template>
  <div class="dropdown-create-item" @click="toggle()" @blur="close()">
    <div class="dropdown-create-item__placeholder">
      <span class="dropdown-create-item__label">Crea nuova</span>
      <i class="dropdown-create-item__icon icon-checvron_bottom">
        <component :is="iconName"></component>
      </i>
    </div>

    <transition name="fade" duration="300">
      <ul
        class="dropdown-create-item__options animation-duration-300 animation-mode-both"
        v-show="focus"
      >
        <li class="dropdown-create-item__option">
          <button
            class="dropdown-create-item__option-label"
            @click="action('podcast')"
          >
            Storia
          </button>
        </li>
        <li class="dropdown-create-item__option">
          <button
            class="dropdown-create-item__option-label"
            @click="action('folder')"
          >
            Cartella
          </button>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
/** Icon */
import IconPlus from '@/assets/icons/icon-plus.svg'
import IconLess from '@/assets/icons/icon-less.svg'

export default {
  components: {
    IconPlus,
    IconLess,
  },

  props: {},

  data() {
    return {
      focus: false,
    }
  },

  computed: {
    iconName() {
      return this.focus ? 'IconLess' : 'IconPlus'
    },
  },

  methods: {
    toggle() {
      this.focus = !this.focus
    },

    open() {
      this.focus = true
    },

    close() {
      this.focus = false
    },

    action(type) {
      this.$emit('CreateItem', type)
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown-create-item {
  @include btn-primary;
  @apply relative cursor-pointer;
}

.dropdown-create-item__label {
  vertical-align: super;
}

.dropdown-create-item__icon {
  @include button-icon-svg;
  @apply ml-4;
}

.dropdown-create-item__options {
  @apply w-full absolute left-0 top-full;
}

.dropdown-create-item__option {
  @apply block w-full border-t border-solid border-white;
}

.dropdown-create-item__option-label {
  @apply block w-full py-4 px-6 bg-blue-500 cursor-pointer;

  &:hover {
    @apply bg-blue-600;
  }
}
</style>
